import React from "react";
import { Table, Divider, Dropdown, Input, Button, Tooltip, Menu } from "antd";
import {
  ApiOutlined,
  CloudServerOutlined,
  EditOutlined,
  FileTextOutlined,
  GroupOutlined,
  MobileOutlined,
  PlusCircleOutlined,
  SearchOutlined,
  TeamOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import {
  ServiceProviderActions,
  ServiceProviderTypes,
  StatusFilters,
  TablePages,
  TablePageSizes,
} from "../../Constants/Constants";
import { StatusSwitch } from "../Common/StatusSwitch";
import {
  createFilter,
  defaultSort,
  getTablePagesize,
  setTablePageSize,
} from "../../Constants/Utilities";
import { BreadCrumbs } from "../Common/BreadCrumbs";

class ListServiceProvider extends React.Component {
  constructor(props) {
    super(props);
    console.log("ListServiceProvider props", props);
    this.state = {
      providerData: props.providerData,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.providerData !== this.props.providerData) {
      this.setState({ providerData: this.props.providerData });
    }
  }

  getColumns = () => [
    {
      title: "Service Provider Name",
      dataIndex: "name",
      sorter: (a, b) => defaultSort(a.name, b.name),
      defaultSortOrder: "ascend",
      width: "40%",
      render: (value, record) => (
        <Button
          type="link"
          onClick={this.props.onActionClick(
            ServiceProviderActions.view,
            record
          )}
        >
          {value}
        </Button>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      filters: createFilter(ServiceProviderTypes),
      onFilter: (value, record) => record.type === value,
      sorter: (a, b) => defaultSort(a.type, b.type),
      width: "30%",
    },
    {
      title: "Active",
      dataIndex: "status",
      align: "center",
      width: "13%",
      filters: StatusFilters,
      onFilter: (value, record) => record.status === value,
      render: StatusSwitch(this.props.onStatusChange),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      align: "center",
      width: "17%",
      render: (_, record) => (
        <div className="entity-list-actions">
          <Tooltip title="View Provider">
            <FileTextOutlined
              className="entity-action"
              onClick={this.props.onActionClick(
                ServiceProviderActions.view,
                record
              )}
            />
          </Tooltip>
          <Tooltip title="Edit Provider">
            <EditOutlined
              className="entity-action"
              onClick={this.props.onActionClick(
                ServiceProviderActions.edit,
                record
              )}
            />
          </Tooltip>
          <Tooltip title="List">
            <Dropdown
              className="entity-action"
              overlay={this.getListMenu(record)}
            >
              <UnorderedListOutlined />
            </Dropdown>
          </Tooltip>
          <Tooltip title="Manage">
            <Dropdown overlay={this.getManageMenu(record)}>
              <PlusCircleOutlined />
            </Dropdown>
          </Tooltip>
        </div>
      ),
    },
  ];

  getListMenu = (record) => {
    const { onActionClick } = this.props;
    return (
      <Menu>
        <Menu.Item
          key="service"
          icon={<CloudServerOutlined />}
          onClick={onActionClick(ServiceProviderActions.service, record)}
        >
          List Services
        </Menu.Item>
        <Menu.Item
          key="entitlement"
          icon={<ApiOutlined />}
          onClick={onActionClick(ServiceProviderActions.entitlement, record)}
        >
          List Entitlements
        </Menu.Item>
        <Menu.Item
          key="devices"
          icon={<MobileOutlined />}
          onClick={onActionClick(ServiceProviderActions.devices, record)}
        >
          List Devices
        </Menu.Item>
        <Menu.Item
          key="deviceGroup"
          icon={<GroupOutlined />}
          onClick={onActionClick(ServiceProviderActions.deviceGroup, record)}
        >
          List Groups
        </Menu.Item>
      </Menu>
    );
  };

  getManageMenu = (record) => {
    const { onActionClick } = this.props;
    return (
      <Menu>
        {record.type === "Aggregator" && (
          <Menu.Item
            key="groupProvider"
            icon={<TeamOutlined />}
            onClick={onActionClick(ServiceProviderActions.group, record)}
          >
            Group Providers
          </Menu.Item>
        )}
        {/* <Menu.Item
          key="assignDevices"
          icon={<PlusSquareOutlined />}
          onClick={onActionClick(ServiceProviderActions.assignDevice, record)}
        >
          Assign Devices
        </Menu.Item>
        <Menu.Item
          key="unassignDevices"
          icon={<MinusSquareOutlined />}
          onClick={onActionClick(ServiceProviderActions.unassignDevice, record)}
        >
          Unassign Devices
        </Menu.Item> */}
      </Menu>
    );
  };

  onSerchTextChange = (e) => {
    const text = e.target.value;
    const { providerData } = this.props;
    if (!!text) {
      const filteredData = providerData.filter((item) =>
        item.name.toLowerCase().includes(text.toLowerCase())
      );
      this.setState({ providerData: filteredData });
      return;
    }
    this.setState({ providerData });
  };

  render() {
    const { providerData } = this.state;
    const { providerDataLoading, onActionClick, parentBread } = this.props;

    return (
      <div className="entity-list-container">
        <div className="page-header-container">
          <BreadCrumbs headers={parentBread} />
        </div>
        <Divider className="divider" />
        <div className="search-add-container">
          <div className="search-container">
            <span className="search-label">Search:</span>
            <Input
              allowClear
              className="search-input"
              placeholder="Enter Provider Name"
              onChange={this.onSerchTextChange}
              suffix={<SearchOutlined style={{ fontSize: 16 }} />}
            />
          </div>
          <div className="add-container">
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={onActionClick(ServiceProviderActions.add)}
            >
              Add Service Provider
            </Button>
          </div>
        </div>
        <Table
          bordered
          size="small"
          columns={this.getColumns()}
          className="entity-table"
          loading={
            providerDataLoading && { tip: "Fetching Service Provider list..." }
          }
          dataSource={providerData}
          pagination={{
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            defaultPageSize: getTablePagesize(TablePages.listServiceProvider),
            pageSizeOptions: TablePageSizes,
            onChange: (_, pageSize) =>
              setTablePageSize(TablePages.listServiceProvider, pageSize),
          }}
        />
      </div>
    );
  }
}

export default ListServiceProvider;
